module.exports = __webpack_public_path__ + "static/media/chess-pawn.c28bc062.svg";